

<ion-content >
  <hr class="styled-divider" [style.backgroundColor]="color">
  <div class="modal-content" >
      <ion-grid>
        <ion-row>
          <ion-col class="d-a-icon" ><ion-icon [name]="icon" [style.color]="color"></ion-icon></ion-col>
          <ion-col size="10">
            <h4 class="d-a-header">{{modalProps?.header || 'Header'}}</h4>
            <div class="d-a-content">{{modalProps?.message || 'Message'}} </div>
          </ion-col>     
        </ion-row>
      </ion-grid>
    <hr class="simple-divider">
    <div *ngIf="!(modalProps.counter)" class="flex-space-evenly button-group">
      <ion-button style="width: 200px; " expand="block" [style.backgroundColor]="color" class="d-a-button" [ngStyle]="{ '--background': color, 'color': '#fff' }" (click)="accept()">{{modalProps?.acceptBtnName || 'Okay'}}</ion-button>
    </div>
    <div *ngIf="modalProps.counter > 0" class="counter-container">
      <span>Counter: </span>
      <span class="counter-value">{{countdownResult}}</span>
    </div>
  </div>
</ion-content>
